import { Action } from "@ngrx/store";
import { FinancialDocument, FinancialDocumentsPagination } from "../models/financial-document.model";

export enum ActionTypes {
  LOAD_FINANCIAL_DOCUMENTS_ARGUMENTS = "[Financial Documents Page V2] Load Financial Documents With Arguments",

  LOAD_FINANCIAL_DOCUMENTS = "[Financial Documents Page V2] Load Financial Documents",
  CLEAR_FINANCIAL_DOCUMENTS = "[Financial Documents Page V2] Clear Financial Documents",
  SEARCH_DOCUMENTS = "[Financial Documents Page V2] Search Documents",
  ADD_FINANCIAL_DOCUMENTS_PAGINATION = "[Financial Documents Page V2] Add financial documents pagination",
  SORT_DOCUMENTS = "[Financial Documents Page V2] Sort Documents",
  SELECT_DOCUMENT = "[Financial Documents Page V2] Select Document",
  FLAG_DOCUMENT = "[Financial Documents Page V2] Flag Document",
  UNFLAG_DOCUMENT = "[Financial Documents Page V2] Unflag Documents",
  DOWNLOAD_EXCEL_REPORT = "[Financial Documents Page V2] Download Excel Report",
  DOWNLOAD_EXCEL_REPORT_V5 = "[Financial Documents Page V2] Download Excel Report V5",
  EXCEL_REPORT_V5_SUCCESSFUL = "[Financial Documents Page V2] Sucess Report V5 Download",
  RESET_DOWNLOADING_STATUS_EXCEL_REPORT_V5 = "[Financial Documents Page V2] Reset Downloading Status Excel Report V5",
  MARK_CHECK = "[Financial Documents Page V2] Mark Check",
  ADD_FINANCIAL_DOCUMENTS = "[Financial Documents API V2] Add Financial Documents",
  CLEAR_DOCUMENT = "[Financial Documents API V2] Clear Document",
  UPDATE_DOCUMENT_DATA = "[Financial Documents API V2] Update Document Data",
  UPDATE_DOCUMENTS_DATA = "[Financial Documents API V2] Update Documents Data",
  ERROR = "[Financial Documents API V2] API error",
  RESET_SEARCH_DOCUMENTS = "[Financial Documents API V2] Reset Search Documents",
}

export class LoadFinancialDocuments implements Action {
  readonly type: string = ActionTypes.LOAD_FINANCIAL_DOCUMENTS;

  constructor(public payload: any = null) {}
}

export class AddFinancialDocuments implements Action {
  readonly type: string = ActionTypes.ADD_FINANCIAL_DOCUMENTS;

  constructor(public payload: FinancialDocument[]) {}
}

export class AddFinancialDocumentsPagination implements Action {
  readonly type: string = ActionTypes.ADD_FINANCIAL_DOCUMENTS_PAGINATION;

  constructor(public payload: FinancialDocumentsPagination) {}
}

export class ClearFinancialDocuments implements Action {
  readonly type: string = ActionTypes.CLEAR_FINANCIAL_DOCUMENTS;

  constructor(public payload: any = null) {}
}

export class FlagDocument implements Action {
  readonly type: string = ActionTypes.FLAG_DOCUMENT;

  constructor(public payload: FinancialDocument) {}
}

export class UnflagDocument implements Action {
  readonly type: string = ActionTypes.UNFLAG_DOCUMENT;

  constructor(public payload: FinancialDocument) {}
}

export class SelectDocument implements Action {
  readonly type: string = ActionTypes.SELECT_DOCUMENT;

  constructor(public payload: number) {}
}

export class ClearDocument implements Action {
  readonly type: string = ActionTypes.CLEAR_DOCUMENT;

  constructor(public payload: any = null) {}
}

export class UpdateDocumentData implements Action {
  readonly type: string = ActionTypes.UPDATE_DOCUMENT_DATA;

  constructor(public payload: FinancialDocument) {}
}

export class UpdateDocumentsData implements Action {
  readonly type: string = ActionTypes.UPDATE_DOCUMENTS_DATA;

  constructor(public payload: FinancialDocument[]) {}
}

export class SetErrorState implements Action {
  readonly type: string = ActionTypes.ERROR;
}
export class SortDocuments implements Action {
  readonly type: string = ActionTypes.SORT_DOCUMENTS;

  constructor(public payload: { columnKey: string; asc: boolean }) {}
}

export class DownloadExcelReport implements Action {
  readonly type: string = ActionTypes.DOWNLOAD_EXCEL_REPORT;

  constructor(public payload: any) {}
}

export class DownloadExcelReportV5 implements Action {
  readonly type: string = ActionTypes.DOWNLOAD_EXCEL_REPORT_V5;

  constructor(public payload: any) {}
}

export class ExcelReporV5Successful implements Action {
  readonly type: string = ActionTypes.EXCEL_REPORT_V5_SUCCESSFUL;

  constructor(public payload: any = null) {}
}

export class ResetDownloadingExcelReporV5 implements Action {
  readonly type: string = ActionTypes.RESET_DOWNLOADING_STATUS_EXCEL_REPORT_V5;

  constructor(public payload: any = null) {}
}

export class SearchDocuments implements Action {
  readonly type: string = ActionTypes.SEARCH_DOCUMENTS;

  constructor(public payload: string) {}
}

export class ResetSearchDocuments implements Action {
  readonly type: string = ActionTypes.RESET_SEARCH_DOCUMENTS;

  constructor(public payload: any = null) {}
}

export class MarkCheck implements Action {
  readonly type: string = ActionTypes.MARK_CHECK;

  constructor(public payload: boolean) {}
}

export class LoadFinancialDocumentsArguments implements Action {
  readonly type: string = ActionTypes.LOAD_FINANCIAL_DOCUMENTS_ARGUMENTS;

  constructor(public payload: any = null) {}
}

export type Actions =
  | LoadFinancialDocuments
  | AddFinancialDocuments
  | ClearFinancialDocuments
  | FlagDocument
  | UnflagDocument
  | SelectDocument
  | ClearDocument
  | UpdateDocumentData
  | UpdateDocumentsData
  | SortDocuments
  | DownloadExcelReport
  | DownloadExcelReportV5
  | SearchDocuments
  | MarkCheck
  | LoadFinancialDocumentsArguments
  | ResetSearchDocuments
  | ExcelReporV5Successful;
